import { type FC, memo, useMemo } from "react";
import type { EventListGridItem } from "src/http/types";
import { BaseDateCardMobile } from "src/website-apps/responsive/stubhub-performer/components/calendar/mobile/BaseDateCardMobile";
import { MlbDateCardMobileBody } from "src/website-apps/responsive/stubhub-performer/components/calendar/mobile/MlbDateCardBodyMobile";
import { usePartnerTheme } from "src/website-apps/shared/hooks/usePartnerTheme";

interface Props {
  events?: EventListGridItem[];
  categoryId?: number;
  loading: boolean;
  openNotificationHandler: (eventId: number) => void;
}

export const MlbDateCardMobile: FC<Props> = memo(({ events = [], categoryId, loading, openNotificationHandler }) => {
  const partnerTheme = usePartnerTheme();

  const { primaryEvent, primaryColor, ariaLabel } = useMemo(() => {
    const [firstEvent] = events;
    const homeGame = firstEvent?.eventMetadata?.sports?.homeTeamId === categoryId;
    const color = homeGame ? partnerTheme.colors?.accent100 : undefined;

    return {
      primaryEvent: firstEvent,
      isHomeGame: homeGame,
      primaryColor: color,
      ariaLabel: firstEvent?.name ?? undefined,
    };
  }, [events, categoryId, partnerTheme.colors?.accent100]);

  if (events.length === 0 || !primaryEvent || loading) {
    return <BaseDateCardMobile loading={loading} />;
  }
  return (
    <BaseDateCardMobile primaryColor={primaryColor} loading={loading} ariaLabel={ariaLabel}>
      <MlbDateCardMobileBody
        events={events}
        primaryColor={primaryColor}
        openNotificationHandler={openNotificationHandler}
      />
    </BaseDateCardMobile>
  );
});
MlbDateCardMobile.displayName = "MlbDateCardMobile";
